import React from 'react';

const SignupImpressionsController = ({ children, impressions }) => {
  return React.cloneElement(children, {
    impressions,
  });
};

export default SignupImpressionsController;
